exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._30yg{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_30yg",
	"root": "_30yg"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./containers/singleBlogue/singleBlogue.css
// module id = 254
// module chunks = 0